(function casaSavedAndMembership(){
  'use strict';

  // ---- helpers ---------------------------------------------------------
  function esc(v){
    try { if (typeof window.escapeHtml === 'function') return window.escapeHtml(v == null ? '' : v); } catch(e){}
    return String(v == null ? '' : v)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function signedIn(){ return !!window.casaUser; }
  function note(msg){
    try { if (typeof window.showToast === 'function') { window.showToast(msg); return; } } catch(e){}
    // Same fallback element casaGuestGate uses, so this looks native either way.
    try {
      var t = document.getElementById('stc-toast');
      if (!t) {
        t = document.createElement('div');
        t.id = 'stc-toast';
        t.style.cssText = 'position:fixed; bottom:32px; left:50%; transform:translateX(-50%) translateY(100px); background:var(--navy); color:#fff; padding:14px 24px; border-radius:4px; box-shadow:0 12px 32px rgba(0,0,0,0.25); z-index:9999; font-size:13px; letter-spacing:0.04em; transition:transform 0.35s var(--ease); max-width:90vw; text-align:center;';
        document.body.appendChild(t);
      }
      t.textContent = msg;
      requestAnimationFrame(function(){ t.style.transform = 'translateX(-50%) translateY(0)'; });
      clearTimeout(t._hideTimer);
      t._hideTimer = setTimeout(function(){ t.style.transform = 'translateX(-50%) translateY(100px)'; }, 4000);
    } catch(e){}
  }
  function money(n){
    var v = Number(n);
    return isFinite(v) && v > 0 ? '$' + v.toLocaleString('en-US', { maximumFractionDigits: 0 }) : 'Price on request';
  }
  function when(d){
    if (!d) return '';
    var t = new Date(d);
    return isNaN(t) ? '' : t.toLocaleDateString(undefined, { year:'numeric', month:'long', day:'numeric' });
  }
  function api(path, opts){
    opts = opts || {};
    return fetch('/api' + path, {
      method: opts.method || 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: opts.body ? JSON.stringify(opts.body) : undefined
    }).then(function(r){
      return r.json().catch(function(){ return null; }).then(function(j){ return { status: r.status, json: j }; });
    }).catch(function(e){ return { status: 0, json: { error: String(e) } }; });
  }
  // Translate ONLY inside a node this module owns. There is deliberately NO
  // helper here that calls the global applyI18n() — see below for why.
  //
  // ⚠️ NEVER call the global applyI18n() from here. #account-title carries
  // data-i18n="modal.welcome" (set at index.html:6806), so every global pass
  // rewrites that heading to "Welcome" — while casaAccountAuthState.render()
  // writes "Welcome back" into the same element on a 700ms interval. The two
  // fight, and the heading visibly flashes between them for as long as the
  // modal stays open. Reported from the preview on 6 Aug 2026.
  //
  // A language switch still translates these panels: they carry real data-i18n
  // attributes and sit in the document, so the storefront's own global pass
  // picks them up. This only removes OUR global calls, not the site's.
  function trStr(key){
    try {
      if (typeof I18N === 'undefined' || !I18N) return '';
      var lang = (typeof currentLang !== 'undefined' && currentLang) || 'en';
      return (I18N[lang] && I18N[lang][key]) || (I18N.en && I18N.en[key]) || '';
    } catch(e){ return ''; }
  }
  function i18nWithin(root){
    if (!root) return;
    try {
      var list = [];
      if (root.getAttribute && root.getAttribute('data-i18n')) list.push(root);
      if (root.querySelectorAll) list = list.concat([].slice.call(root.querySelectorAll('[data-i18n]')));
      list.forEach(function(el){
        var v = trStr(el.getAttribute('data-i18n'));
        // Mirrors applyI18n's own rule: only elements with no child elements.
        if (v && el.children.length === 0 && el.textContent !== v) el.textContent = v;
      });
    } catch(e){}
  }

  // ---- translations ----------------------------------------------------
  // Merged into the shared dictionary the same way PRIVATE_I18N does it. I18N is
  // a top-level `const` in an earlier <script>, so it is a global lexical
  // binding reachable by bare name — but never assume: a typeof guard means a
  // future refactor that scopes it can only cost us translations, not the feature.
  var WL_I18N = {
    en: { 'common.savedWishlist':'♥ Saved to Wishlist', 'wl.title':'Your wishlist', 'wl.empty':'Nothing saved yet. Tap the heart on any piece and it will be waiting here for you.', 'mem.title':'Your membership', 'mem.none':'You are not a Concierge Club member. Membership adds priority evaluation, early access and white-glove service.', 'contact.name':'Your name', 'contact.email':'Your email', 'contact.emailNote':'So we can reply. We only use it to answer this message.', 'cat.membership':'Concierge Club / membership', 'cat.feedback':'Compliment or feedback' },
    es: { 'common.savedWishlist':'♥ Guardado en Favoritos', 'wl.title':'Tus favoritos', 'wl.empty':'Aún no has guardado nada. Toca el corazón en cualquier pieza y te esperará aquí.', 'mem.title':'Tu membresía', 'mem.none':'No eres miembro del Concierge Club. La membresía añade evaluación prioritaria, acceso anticipado y servicio guante blanco.', 'contact.name':'Tu nombre', 'contact.email':'Tu correo', 'contact.emailNote':'Para poder responderte. Solo lo usamos para contestar este mensaje.', 'cat.membership':'Concierge Club / membresía', 'cat.feedback':'Felicitación o comentario' },
    fr: { 'common.savedWishlist':'♥ Sauvegardé', 'wl.title':'Vos favoris', 'wl.empty':'Rien de sauvegardé pour le moment. Touchez le cœur sur une pièce et elle vous attendra ici.', 'mem.title':'Votre adhésion', 'mem.none':"Vous n'êtes pas membre du Concierge Club. L'adhésion apporte une évaluation prioritaire, un accès anticipé et un service gant blanc.", 'contact.name':'Votre nom', 'contact.email':'Votre e-mail', 'contact.emailNote':'Pour pouvoir vous répondre. Utilisé uniquement pour répondre à ce message.', 'cat.membership':'Concierge Club / adhésion', 'cat.feedback':'Compliment ou retour' },
    de: { 'common.savedWishlist':'♥ Auf der Wunschliste', 'wl.title':'Ihre Wunschliste', 'wl.empty':'Noch nichts gespeichert. Tippen Sie bei einem Stück auf das Herz — es wartet dann hier auf Sie.', 'mem.title':'Ihre Mitgliedschaft', 'mem.none':'Sie sind kein Mitglied des Concierge Club. Die Mitgliedschaft bietet vorrangige Bewertung, frühen Zugang und Weiße-Handschuhe-Service.', 'contact.name':'Ihr Name', 'contact.email':'Ihre E-Mail', 'contact.emailNote':'Damit wir antworten können. Wird nur zur Beantwortung dieser Nachricht verwendet.', 'cat.membership':'Concierge Club / Mitgliedschaft', 'cat.feedback':'Lob oder Feedback' },
    ja: { 'common.savedWishlist':'♥ 保存済み', 'wl.title':'ウィッシュリスト', 'wl.empty':'まだ保存された品はありません。ハートに触れると、ここでお待ちしています。', 'mem.title':'ご加入状況', 'mem.none':'コンシェルジュクラブ未加入です。ご加入で優先査定、先行アクセス、ホワイトグローブサービスをご利用いただけます。', 'contact.name':'お名前', 'contact.email':'メールアドレス', 'contact.emailNote':'ご返信のために使用します。このお問い合わせへの回答にのみ利用します。', 'cat.membership':'コンシェルジュクラブ / 会員', 'cat.feedback':'ご感想・ご意見' },
    zh: { 'common.savedWishlist':'♥ 已加入愿望清单', 'wl.title':'您的愿望清单', 'wl.empty':'尚未收藏任何单品。轻触任意单品上的爱心，它就会在这里等您。', 'mem.title':'您的会员资格', 'mem.none':'您尚未加入礼宾俱乐部。会员可享优先鉴定、抢先选购与白手套服务。', 'contact.name':'您的姓名', 'contact.email':'您的邮箱', 'contact.emailNote':'以便我们回复。仅用于回复此条留言。', 'cat.membership':'礼宾俱乐部 / 会员', 'cat.feedback':'表扬或反馈' }
  };
  try {
    if (typeof I18N !== 'undefined' && I18N) {
      Object.keys(WL_I18N).forEach(function(lang){
        if (I18N[lang]) Object.assign(I18N[lang], WL_I18N[lang]);
      });
      // Scoped to the contact modal — the only shipped markup these new keys
      // are attached to. A global pass here would be safe at load (the account
      // modal is closed and nobody is signed in yet), but see the i18nWithin
      // note: this module must never widen its blast radius.
      i18nWithin(document.getElementById('modal-contact'));
    }
  } catch(e){ console.warn('[casa][wishlist] i18n merge skipped', e); }

  var STATUS_LABEL = {
    active:     ['Active', 'on'],
    cancelling: ['Cancelling', 'warn'],
    lapsed:     ['Lapsed', 'warn'],
    cancelled:  ['Cancelled', ''],
    refunded:   ['Refunded', ''],
    selected:   ['Awaiting payment', 'warn']
  };

  // ---- state -----------------------------------------------------------
  var saved = null;        // Set of SKUs, or null until first load
  var pendingSku = null;   // saved automatically once they sign in
  var lastWho = null;

  function refreshSaved(){
    if (!signedIn()) { saved = null; paintButton(); return Promise.resolve(); }
    return api('/wishlist').then(function(r){
      if (r.status === 200 && r.json && Array.isArray(r.json.items)) {
        saved = new Set(r.json.items.map(function(i){ return i.sku; }));
      }
      paintButton();
    });
  }

  // ---- the heart button ------------------------------------------------
  function heart(){ return document.querySelector('.quickview-info .btn-ghost.btn-block'); }
  function currentSku(){
    var el = document.getElementById('qv-sku');
    var v = (el && el.textContent || '').trim();
    // Before hydrateCatalog() replaces `arrivals` from the DB (~400ms after
    // load) the seed objects have no `sku` at all, so this reads "undefined".
    // Saving that string would create a row pointing at nothing.
    return (!v || v === 'undefined') ? '' : v;
  }
  function paintButton(){
    var b = heart(); if (!b) return;
    var sku = currentSku();
    var isSaved = !!(sku && saved && saved.has(sku));
    // Swap the KEY, never the text. applyI18n re-reads data-i18n on every
    // language switch and would overwrite a textContent write on the next one.
    b.setAttribute('data-i18n', isSaved ? 'common.savedWishlist' : 'common.saveWishlist');
    b.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    i18nWithin(b);
  }

  function save(sku){
    return api('/wishlist', { method:'POST', body:{ sku: sku } }).then(function(r){
      if (r.status === 200 && r.json && r.json.ok) {
        if (!saved) saved = new Set();
        saved.add(sku);
        paintButton(); paintPanels();
        note('Saved to your wishlist — find it under your account.');
        return true;
      }
      if (r.status === 401) { promptSignIn(sku); return false; }
      note((r.json && r.json.error) || 'Could not save that just now. Please try again.');
      return false;
    });
  }
  function unsave(sku){
    return api('/wishlist', { method:'DELETE', body:{ sku: sku } }).then(function(r){
      if (r.status === 200) {
        if (saved) saved.delete(sku);
        paintButton(); paintPanels();
        note('Removed from your wishlist.');
      }
    });
  }

  // Sign-in prompt, shaped like casaGuestGate's so a guest sees one consistent
  // "you need an account" moment across the site. Unlike the Club gate this one
  // DOES resume: saving a piece is free and reversible, so completing it for
  // them is a courtesy, not a charge they did not confirm.
  var PROMPT_TITLE = 'Save this piece';
  var PROMPT_SUB = 'Sign in or create an account and we will keep it on your wishlist.';
  var promptShowing = false;

  // Re-asserted rather than written once. Three different things repaint this
  // header — updateAccountUI() (index.html:12613), switchTab()'s per-tab titles,
  // and casaAccountAuthState.render() — and updateAccountUI in particular fires
  // on the signed-in -> signed-out transition, which is exactly when somebody
  // lands here. Observed overwriting the copy ~250ms after the click, leaving a
  // guest with a generic "Welcome" and no idea why they were asked to sign in.
  function applyPromptCopy(){
    if (!promptShowing) return;
    var t = document.getElementById('account-title');
    var s = document.getElementById('account-sub');
    if (t && t.textContent !== PROMPT_TITLE) t.textContent = PROMPT_TITLE;
    if (s && s.textContent !== PROMPT_SUB) s.textContent = PROMPT_SUB;
  }
  function clearPrompt(){ promptShowing = false; }

  function promptSignIn(sku){
    pendingSku = sku || null;
    promptShowing = true;
    // Close the quick view FIRST. #modal-quickview and #modal-account share
    // z-index 300 and the quick view is later in the DOM, so it paints on top —
    // the account modal opened silently BEHIND it and a guest saw nothing happen
    // at all. Stacking two full-screen modals is the wrong answer regardless;
    // the sign-in prompt is the feedback here, and the piece is remembered in
    // pendingSku and saved for them the moment they are in.
    try { if (typeof closeModal === 'function') closeModal('quickview'); } catch(e){}
    try { if (typeof openModal === 'function') openModal('account'); } catch(e){}
    setTimeout(function(){
      try { if (typeof switchTabByName === 'function') switchTabByName('signin'); } catch(e){}
      applyPromptCopy();
    }, 60);
  }

  // Capture phase on document, so this runs BEFORE the button's own inline
  // onclick="closeModal('quickview')" and can cancel it. The quick view stays
  // open on purpose — the heart changes state, and closing the modal would hide
  // the only feedback there is.
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest('.quickview-info .btn-ghost.btn-block') : null;
    if (!b) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var sku = currentSku();
    if (!sku) { note('This piece is still loading — one moment, then try again.'); return; }
    if (!signedIn()) { promptSignIn(sku); return; }
    if (saved && saved.has(sku)) unsave(sku); else save(sku);
  }, true);

  // Repaint the heart whenever the quick view opens onto a different piece.
  try {
    var qv = document.getElementById('modal-quickview');
    if (qv) new MutationObserver(function(){
      if (qv.classList.contains('open')) setTimeout(paintButton, 30);
    }).observe(qv, { attributes: true, attributeFilter: ['class'] });
  } catch(e){}

  // ---- account modal panels -------------------------------------------
  // Order is Your orders -> Your wishlist -> Your membership. casaOrders owns
  // its own node and re-inserts it after #account-sub whenever it repaints, so
  // position is re-asserted on every paint rather than set once.
  function modal(){ return document.getElementById('modal-account'); }

  function panel(cls){
    var m = modal(); if (!m) return null;
    var el = m.querySelector('.' + cls);
    if (!el) {
      el = document.createElement('div');
      el.className = cls;
    }
    return el;
  }
  // Takes the nodes as arguments. It used to look them up with
  // m.querySelector('.casa-wish'), which can never find a node panel() has just
  // built — that node is DETACHED until something appends it, and place() was
  // the only thing that would have. Neither panel ever reached the DOM, so the
  // account modal showed "Your orders" and nothing else.
  //
  // insertBefore moves an existing node and inserts a new one, so this both
  // attaches on the first paint and re-asserts the order on every later one.
  function place(w, mem){
    var m = modal(); if (!m) return;
    if (!w) w = m.querySelector('.casa-wish');
    if (!mem) mem = m.querySelector('.casa-mem');
    // Anchor to the orders panel when it exists. Before it does, anchor to
    // #account-sub — casaOrders inserts itself immediately after that same node,
    // which pushes these two down and still lands orders → wishlist → membership.
    var anchor = m.querySelector('.casa-orders') || document.getElementById('account-sub');
    if (!anchor || !anchor.parentNode) return;
    if (w) anchor.parentNode.insertBefore(w, anchor.nextSibling);
    if (mem) anchor.parentNode.insertBefore(mem, (w || anchor).nextSibling);
  }

  function wishHtml(items){
    if (!items.length) return '<p class="empty" data-i18n="wl.empty">Nothing saved yet. Tap the heart on any piece and it will be waiting here for you.</p>';
    return items.map(function(it){
      var img = it.image ? '<div class="thumb" style="background-image:url(\'' + esc(it.image) + '\')"></div>' : '<div class="thumb"></div>';
      // A saved piece that has since sold still shows — dropping it silently
      // would look like we lost their list.
      var price = it.available ? '<div class="amt">' + esc(money(it.price)) + '</div>'
                               : '<div class="amt gone">No longer available</div>';
      return '<div class="casa-wish-row">' + img +
               '<div class="ttl"><span class="br">' + esc(it.brand) + '</span>' + esc(it.name) + '</div>' +
               price +
               '<div class="ttl" style="grid-column:2"><span class="br" style="text-transform:none;letter-spacing:.04em">' + esc(it.sku) + '</span></div>' +
               '<button class="rm" type="button" data-unsave="' + esc(it.sku) + '" aria-label="Remove from wishlist" title="Remove">&times;</button>' +
             '</div>';
    }).join('');
  }

  function memHtml(m){
    if (!m) return '<p class="empty" data-i18n="mem.none">You are not a Concierge Club member. Membership adds priority evaluation, early access and white-glove service.</p>';
    var st = STATUS_LABEL[m.status] || [m.status, ''];
    var portal = '';
    try { portal = (window.CASA_CONFIG || {}).MEMBER_PORTAL_URL || ''; } catch(e){}
    var meta = [];
    if (m.since) meta.push('Member since ' + esc(when(m.since)));
    if (m.lastPaidAt) meta.push('Last payment ' + esc(when(m.lastPaidAt)));
    if (m.currentPeriodEnd && (m.status === 'active' || m.status === 'cancelling')) {
      meta.push((m.status === 'cancelling' ? 'Access until ' : 'Renews ') + esc(when(m.currentPeriodEnd)));
    }
    if (m.status === 'selected') meta.push('Selected, but no payment recorded yet.');
    return '<div class="tier"><strong>' + esc(m.tierLabel) + '</strong>' +
             (m.price ? ' &middot; $' + esc(Number(m.price).toLocaleString()) + '/' + (m.billingInterval === 'yearly' ? 'year' : 'month') : '') +
             '<span class="pill ' + st[1] + '">' + esc(st[0]) + '</span></div>' +
           (meta.length ? '<div class="meta">' + meta.join('<br>') + '</div>' : '') +
           (portal ? '<div class="meta"><a href="' + esc(portal) + '">Manage membership &rarr;</a></div>' : '') +
           // Same box as the Club page's "Change tier or cancel" (24 Sep 2026).
           '<div class="meta"><a href="#" onclick="event.preventDefault(); try{ closeModal(\'account\'); }catch(e){} if (window.casaManageClub) window.casaManageClub();">Change tier or cancel &rarr;</a></div>';
  }

  function paintPanels(){
    var m = modal(); if (!m) return;
    var w = m.querySelector('.casa-wish'), mem = m.querySelector('.casa-mem');

    // Signed out: remove both rather than leave somebody else's list on screen.
    if (!signedIn()) {
      if (w && w.parentNode) w.parentNode.removeChild(w);
      if (mem && mem.parentNode) mem.parentNode.removeChild(mem);
      return;
    }

    w = panel('casa-wish'); mem = panel('casa-mem');
    if (!w.innerHTML) w.innerHTML = '<h4 data-i18n="wl.title">Your wishlist</h4><p class="empty">Loading…</p>';
    if (!mem.innerHTML) mem.innerHTML = '<h4 data-i18n="mem.title">Your membership</h4><p class="empty">Loading…</p>';
    place(w, mem);

    api('/wishlist').then(function(r){
      if (!signedIn()) return;
      var items = (r.json && r.json.items) || [];
      saved = new Set(items.map(function(i){ return i.sku; }));
      w.innerHTML = '<h4 data-i18n="wl.title">Your wishlist</h4>' + wishHtml(items);
      place(w, mem); i18nWithin(w); paintButton();
    });

    api('/membership').then(function(r){
      if (!signedIn()) return;
      var rec = (r.json && r.json.membership) || null;
      mem.innerHTML = '<h4 data-i18n="mem.title">Your membership</h4>' + memHtml(rec);
      place(w, mem); i18nWithin(mem);
      // SECURITY: this replaces the localStorage stand-in that casaIsMember()
      // used to trust. Server truth, or null — never the browser's word.
      try {
        window.casaMembership = window.casaMembership || {};
        window.casaMembership.tier = (rec && (rec.status === 'active' || rec.status === 'cancelling')) ? rec.tier : null;
      } catch(e){}
    });
  }

  // Remove buttons are delegated: the rows are rebuilt on every paint.
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest('.casa-wish [data-unsave]') : null;
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    unsave(b.getAttribute('data-unsave'));
  });

  // ---- membership selection beacon ------------------------------------
  // NOT a wrapper around casaStartMembership. That function is already wrapped
  // twice — by the legal gate (which re-installs itself on four timers behind a
  // __legal flag) and by casaGuestGate — and its own comment warns that a third
  // wrapper risks double-prompting the Terms or prompting before sign-in.
  // A passive listener records the selection and leaves the call chain alone.
  //
  // This does NOT preventDefault. Registered after casaGuestGate, so when a
  // guest clicks, that gate's stopImmediatePropagation stops this too — which is
  // correct: they have not selected anything yet, they are being asked to sign in.
  document.addEventListener('click', function(e){
    if (!signedIn()) return;
    var el = e.target && e.target.closest ? e.target.closest('button[onclick], a[onclick]') : null;
    if (!el) return;
    var src = el.getAttribute('onclick') || '';
    var m = src.match(/casaStartMembership\(\s*['"](silver|gold|elite)['"]\s*\)/);
    if (!m) return;
    // keepalive so the request survives the navigation to Shopify's checkout,
    // which casaStartMembership triggers a moment later.
    try {
      fetch('/api/membership', {
        method: 'POST', keepalive: true, credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tier: m[1], interval: window.casaMembershipInterval === 'yearly' ? 'yearly' : 'monthly' })
      }).catch(function(){});
    } catch(err){}
  }, true);

  // ---- contact modal: prefill, and reset when reopened ------------------
  // The footer links call openModal('contact') directly rather than
  // openContactTicket(), so after one successful ticket the modal would reopen
  // still showing the confirmation with no form. Reset on open instead of
  // touching those five links.
  try {
    var cm = document.getElementById('modal-contact');
    if (cm) new MutationObserver(function(){
      if (!cm.classList.contains('open')) return;
      setTimeout(function(){
        var frm = document.getElementById('contact-form');
        var suc = document.getElementById('contact-success');
        var body = document.getElementById('contact-body');
        if (body) body.style.display = '';
        if (suc && suc.style.display === 'block') { suc.style.display = 'none'; if (frm) { frm.style.display = ''; frm.reset(); } }
        else if (frm) frm.style.display = '';
        // Prefill from the session so a signed-in member does not retype what
        // we already know. Left editable: they may be writing about an order
        // placed under a different address.
        var nm = document.getElementById('contact-name');
        var em = document.getElementById('contact-email');
        if (signedIn()) {
          if (nm && !nm.value) nm.value = window.casaUser.name || '';
          if (em && !em.value) em.value = window.casaUser.email || '';
        }
      }, 20);
    }).observe(cm, { attributes: true, attributeFilter: ['class'] });
  } catch(e){}

  // ---- keep in step with the session -----------------------------------
  // casaUser is filled in by an async /auth/me and changes on sign-in and
  // sign-out with no event we own — the same reason casaOrders polls.
  refreshSaved();
  setInterval(function(){
    var who = (window.casaUser && window.casaUser.email) || null;
    if (who !== lastWho) {
      lastWho = who;
      refreshSaved().then(function(){
        // Finish what they were doing before we asked them to sign in.
        if (who && pendingSku) { var s = pendingSku; pendingSku = null; clearPrompt(); save(s); }
        if (who) clearPrompt();
        var m = modal();
        if (m && m.classList.contains('open')) paintPanels();
      });
    }
    var m2 = modal();
    if (m2 && m2.classList.contains('open') && signedIn() && !m2.querySelector('.casa-wish')) paintPanels();
  }, 700);

  try {
    var am = modal();
    if (am) new MutationObserver(function(){
      if (am.classList.contains('open')) setTimeout(paintPanels, 40);
      else clearPrompt();   // they closed it — stop re-asserting the prompt copy
    }).observe(am, { attributes: true, attributeFilter: ['class'] });
  } catch(e){}

  // Win the race against whatever repaints the header, rather than hoping to be
  // last. Re-applying only when the text differs means our own write cannot
  // retrigger this into a loop.
  try {
    var hdr = new MutationObserver(applyPromptCopy);
    ['account-title', 'account-sub'].forEach(function(id){
      var el = document.getElementById(id);
      if (el) hdr.observe(el, { childList: true, characterData: true, subtree: true });
    });
  } catch(e){}

  console.log('%cCASA · Wishlist + membership record', 'background:#141414;color:#fff;padding:4px 10px;font-weight:bold;');
  console.log('  ✓ Save to Wishlist persists per account; guests are prompted and the save resumes after sign-in');
  console.log('  ✓ Your wishlist + Your membership render in the account modal, below Your orders');
  console.log('  ✓ Membership status now comes from /api/membership, not localStorage');
})();
